import "./Media.css"; 

export function MediaNetWorkMessage(showInfo) {
  const showDiv = showInfo.info ? "0px" : "-100px";
  return (
    <div
      style={{
        position: "fixed",
        width: "270px",
        left: "50%",
        marginLeft: "-130px",
        bottom: showDiv,
        backgroundColor: "rgb(24, 24, 24)",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "rgba(0, 0, 0, 0.3) 3px 4px 20px 0px",
        padding: "15px",
        color: "rgb(168, 156, 127)",
        fontSize: "12px",
        lineHeight: "25px",
        transition: "bottom 1s ease 0s",
        zIndex: "3",
      }}
    >
      <div
        style={{
          border: "1px solid #a89c7f",
          width: "27px",
          height: "27px",
          borderRadius: "25px",
          fontSize: "16px",
          float: "left",
          marginRight: "10px",
          textAlign: "center",
        }}
      >
        i
      </div>
      <span>{showInfo.infoText}</span>
    </div>
  );
}